import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import translationEN from './locales/en.json';
import translationSE from './locales/sv.json';
// import translationFI from './locales/fi.json';

const resources = {
  en: {
    translation: translationEN,
  },
  se: {
    translation: translationSE,
  },
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'se',
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
    saveMissing: true,
    missingKeyHandler: (lngs, ns, key, fallbackValue, updateMissing, options) => {

      console.log(`%c"${key}" is not translated in "${lngs}"`, "color: red; font-weight: bold");

    }
  }
);

export default i18n;
